import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output, ViewChild
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";
import * as _ from "lodash";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {Subscription} from "rxjs";
import {BranchesComponentStore} from "../../state/branches-component.store";
import {BranchModel} from "../../../models/branch.model";
import {BranchReferenceModel} from "../../../models/branch-reference.model";

interface BranchesMultiSelectListModel {
  selectedIds: string[];
  excludeIds: string[];
  options: BranchModel[] | BranchReferenceModel[];
  optionIds: string[];
  ngPlaceholder: any;
}

require('./branches-multi-select-list.scss');
@Component({
  standalone: false,
  selector: 'app-branches-multi-select-list',
  templateUrl: './branches-multi-select-list.html',
  providers: [BranchesComponentStore],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BranchesMultiSelectListComponent implements OnInit, OnDestroy {

  @Output() onClose = new EventEmitter<any>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public options: BranchModel[] | BranchReferenceModel[];
  public selectedBranchIds: string[];
  public queryString: string = '';
  public selectedKeys: any;
  public excludedMap: any;
  public loadLimit: number = 20;
  public branches: BranchModel[] | BranchReferenceModel[];
  public ngPlaceholder: string;
  public branchesSubscription: Subscription;
  public cursor: string;
  public isLoading: boolean;

  constructor(@Inject(PANEL_DATA) public data: BranchesMultiSelectListModel, @Inject(BranchesComponentStore) private branchesStore: BranchesComponentStore,
              @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.selectedBranchIds = this.data.selectedIds;
    this.ngPlaceholder = this.data.ngPlaceholder;
    this.options = this.data.options;

    this.setExcludedIdsMap(this.data.excludeIds);

    this.setSelectedIdsMap();

    if(!!this.options) {
      this.branches = this.options;
    } else {
      this._getBranches();
      this.branchesSubscription = this.branchesStore.vm$.subscribe((vm) => {
        this.cursor = vm.cursor;
        this.isLoading = vm.loading;
        this.branches = vm.branches;
        this.cdkVirtualScrollViewport?.checkViewportSize();
        this.cdr.detectChanges();
      })
    }
  }

  ngOnDestroy() {
    this.branchesStore.onResetBranches();
    this.branchesSubscription?.unsubscribe();
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 150 && this.cursor && !this.isLoading) {
      this._getBranches();
    }
  }

  onToggle(branchId, isSelected) {
    this.selectedBranchIds = !isSelected ? _.concat(this.selectedBranchIds || [], [branchId]) :
      _.filter(this.selectedBranchIds, (id) => {
        return id !== branchId;
      });

    this.setSelectedIdsMap();
  }

  onSubmit() {
    this.onClose.emit({branchIds: this.selectedBranchIds})
  }

  onReset() {
    this.onClose.emit({branchIds: []})
  }

  onCancel() {
    this.onClose.emit({branchIds: this.data.selectedIds})
  }

  onQueryChange(query) {
    this.queryString = query;
    this._resetStore();
    this._getBranches();
  }

  onToggleSelectAll() {
    if (this.branches?.length === this.selectedBranchIds?.length) {
      this.selectedBranchIds = []
      this.setSelectedIdsMap();
    } else {
      this.selectedBranchIds = this.branches.map((a) => a.id);
      this.setSelectedIdsMap();
    }
  }

  private setExcludedIdsMap(excludeIds) {
    this.excludedMap = {};
    _.forEach(excludeIds, (id) => {
      this.excludedMap[id] = true;
    })
  }

  private setSelectedIdsMap() {
    this.selectedKeys = {};
    _.forEach(this.selectedBranchIds, (id) => {
      this.selectedKeys[id] = true;
    })
  }

  private _resetStore() {
    this.branchesStore.resetBranches();
  }

  private _getBranches() {
    this.branchesStore.getBranches(this._getQueryPayload());
  }

  private _getQueryPayload() {
    const params = {
      limit: this.loadLimit,
      query: this.queryString,
      sort: 'name,asc'
    };

    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    return params;
  }

}
